(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-bundelkorting"] && !Shopify.designMode) return;
  try {
    function mbBundelKies(rij) {
    var blok = rij.closest('[data-mb-bundel]');
    var veld = null;
    var ouder = blok.parentElement;
    while (ouder && !veld) {
      veld = ouder.querySelector('input[name="quantity"]');
      ouder = ouder.parentElement;
    }
    if (veld) {
      veld.value = rij.dataset.aantal;
      veld.dispatchEvent(new Event('change', { bubbles: true }));
      veld.dispatchEvent(new Event('input', { bubbles: true }));
    }
    blok.querySelectorAll('.mb-bundel__rij').forEach(function (r) {
      r.setAttribute('aria-pressed', r === rij ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var rij = event.target.closest('[data-mb-bundel] .mb-bundel__rij');
    if (rij) mbBundelKies(rij);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var rij = event.target.closest('[data-mb-bundel] .mb-bundel__rij');
    if (!rij) return;
    event.preventDefault();
    mbBundelKies(rij);
  });
  } catch(e) { console.error(e); }
})();

})();
